// passkeyRp — NEXUS rebrand Phase 2 (group 7) WebAuthn hard cutover (frontend).
//
// Passkeys bind to the page origin's RP_ID. After the hard cutover, the ONLY
// supported origin for the passkey enrolment / verification ceremony is
// nexus.sentry.red (plus localhost in dev). The legacy location origin is
// decommissioned for passkeys — a page loaded there must show a clear "re-enrol
// on the new domain" message instead of running a ceremony that the browser
// would reject with a confusing RP-mismatch error.

export const PASSKEY_RP_HOST = "nexus.sentry.red";

/** True when the current page host may run the WebAuthn passkey ceremony.
 *  Production: nexus only. Dev: localhost / 127.0.0.1. Everything else
 *  (legacy location, unknown) → false so the UI fails closed. */
export function isSupportedPasskeyHost(host: string | null | undefined): boolean {
  if (!host) return false;
  const h = host.split(":")[0].trim().toLowerCase();
  return h === PASSKEY_RP_HOST || h === "localhost" || h === "127.0.0.1";
}

/** zh-TW message shown when the enrol page is opened on a non-nexus origin. */
export const PASSKEY_HOST_UNSUPPORTED_MESSAGE =
  "Passkey 註冊已移至新網域 nexus.sentry.red（舊網域已停用）。請改用新網域的註冊連結重新註冊；若連結仍指向舊網域，請聯絡管理員重新發送。";
